import { render } from "./AddSampleForm.vue?vue&type=template&id=53c03d31"
import script from "./AddSampleForm.vue?vue&type=script&lang=js"
export * from "./AddSampleForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__